import { RECOMMENDATION_STATE } from 'features/framework/pages/MyProfileRecommendations/Recommendations.config';


export const selectRecommendations = (store) => store.assessments.recommendations;

export const selectRecommendationsUnarchived = (store) => (selectRecommendations(store) ?? [])
.filter(({ state }) => [ RECOMMENDATION_STATE.ACTIVE, RECOMMENDATION_STATE.BOOKMARKED ].includes(state));
